// Pure decision for the camera modal's background retry tick. A 28181 camera
// must recover exactly like RTMP from the user's view; the only difference is
// that WVP only starts pulling on a play request, so a not-streaming 28181 feed
// needs an explicit (lightweight) viewer/start each tick instead of a passive
// state/probe check.
//
//   "disabled" - the camera is switched off (active === 0); never start.
//   "resolve"  - just resolve the state we already have (already streaming,
//                misconfigured with no hls_url, in the player-failure cooldown,
//                or not a 28181 camera).
//   "start"    - 28181, enabled, not streaming, has an hls_url: ask the backend
//                to start the play.
export const GB28181_PROTOCOL = "gb28181";

export function gbRetryAction(stateData, { inCooldown }) {
  if (stateData.active === 0) return "disabled";
  if (stateData.live === "streaming" || !stateData.hls_url || inCooldown) {
    return "resolve";
  }
  if (stateData.protocol === GB28181_PROTOCOL && stateData.active === 1) {
    return "start";
  }
  return "resolve";
}
